<template>
  <grid :config="{searchFields: ['title', 'venue', 'date', 'organisation']}" :data="eventData" class="u-1-of-1">
    <template v-slot:gridHeader>
      <div class="o-layout c-list__row u-padding-horizontal-small">
        <div class="o-layout__item u-3-of-8-at-medium">
          {{$t('title')}}
        </div>
        <div class="o-layout__item u-1-of-8-at-medium u-1-of-2-at-tiny">
          {{$t('venue')}}
        </div>
        <div class="o-layout__item u-1-of-4-at-medium u-1-of-2-at-tiny">
          {{$t('date')}}
        </div>
        <div class="o-layout__item u-1-of-4-at-medium u-1-of-2-at-tiny">
          {{$t('organisation')}}
        </div>
      </div>
    </template>
    <template v-slot:gridData="{element}">
      <div class="o-layout__item u-3-of-8-at-medium c-list__main-cell">
        <router-link class="c-list__link" :to="{ name: 'event.view', params: { eventId: element.id}}">
          {{element.title}}
        </router-link>
      </div>
      <div class="o-layout__item u-1-of-8-at-medium u-1-of-2-at-tiny">
        {{element.venue}}
      </div>
      <div class="o-layout__item u-1-of-4-at-medium u-1-of-2-at-tiny">
        {{element.date}}
      </div>
      <div class="o-layout__item u-1-of-4-at-medium u-1-of-1-at-tiny">
        {{element.organisation}}
      </div>
    </template>
  </grid>
</template>
<script>
  const moment = require('moment')
  import find from 'lodash/find';
  import map from 'lodash/map';
  import sortBy from 'lodash/sortBy';

  export default {
    name:'eventsList',
    components: {
      grid: require('client/components/dataGrid.vue').default,
    },
    data: function() {
      return {
        isLocal: false,
        eventData: [],
      }
    },
    computed: {
      events: function() {
        return sortBy(this.$store.state.events.items, ['date_from', 'title']).reverse()
      },
      organisations: function() {
        return this.$store.state.organisations.items
      },
    },
    created: function() {
      this.init()
    },
    watch: {
      events: function() {
        this.init()
      },
    },
    methods: {
      init: function() {
        this.isLocal = this.$store.state.environment.local
        this.eventData = map(this.events, item => {
          let event = {
            id: item.id,
            title: item.title,
            venue: item.venue,
            date: this.format(item.date_from) + ' - ' + this.format(item.date_to),
          }

          const org = find(this.organisations, o => item.organisationId === o.id )
          if (org) {
            event.organisation = org.name
          } else {
            event.organisation = this.$t('missing')
          }

          return event
        })
      },
      format: function(date){
        return moment(date).format('DD/MM/YYYY')
      },
    }
  };
</script>
